<template>
  <v-expansion-panels flat accordion multiple :value="[state]" v-model="expanded">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <v-expansion-panel v-for="(item, i) in items" :key="i">
      <v-expansion-panel-header
        class="text-uppercase px-0"
        @click="expandHandler(item)"
      >
        <span class="text-tcdc-green header bold">{{ item[`title_${lang}`] }}</span>
        <template v-slot:actions>
          <v-icon v-if="expanded.some(index => i === index)" class="text-tcdc-green" size="medium">mdi-minus</v-icon>
          <v-icon v-else class="text-tcdc-green" size="medium">mdi-plus</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <TCDCResourceCenter v-if="item.slug.includes('tcdc-resource-center')" />
        <Material v-if="item.slug.includes('material')"/>
        <Database v-if="item.slug.includes('database')" />
        <Article v-if="item.slug.includes('article')" />
        <Ebook v-if="item.slug.includes('ebook')"/>
        <OnlineExhibition v-if="item.slug.includes('online-exhibition')" />
        <DesignCalendar v-if="item.slug.includes('design-world-calendar')"/>
      </v-expansion-panel-content>
      <Divider v-if="shouldRenderBottomBorder(i+1, items.length)" />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Divider from "../../components/dividers/Divider";
import TCDCResourceCenter from "../../screens/resource_center/TCDCResourceCenter";
import Material from "../../screens/resource_center/Material";
import Database from "../../screens/resource_center/Database";
import Article from "../../screens/resource_center/Article";
import Ebook from "../../screens/resource_center/Ebook";
import OnlineExhibition from "../../screens/resource_center/OnlineExhibition";
import DesignCalendar from "../../screens/resource_center/DesignCalendar";
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex';
export default {
  data: () => ({
    expanded: [],
    isLoading: false
  }),
  props: {
    items: {
      default: []
    },
    bottomBorderVisible: {
      type: Boolean,
      default: true
    },
    expandable: {
      type: Boolean,
      default: false
    },
    state: {
      default : null
    }
  },
  components: {
    Divider,
    TCDCResourceCenter,
    Material,
    Database,
    Article,
    Ebook,
    OnlineExhibition,
    Loading,
    DesignCalendar
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  },
  created() {
    if (this.state) {
      this.expanded.push(this.state);
    }
  },
  methods: {
    shouldRenderBottomBorder(index, length) {
      if (index >= length) {
        return this.bottomBorderVisible;
      } else {
        return true;
      }
    },
    async expandHandler(item) {
      // const prev = this.expanded[index];
      this.isLoading = true;
      if (!this.expandable) {
        // check have '&' symbol
        let do_seo = item.title_en.replace('&', 'and');
        let title = do_seo.replace(/ /g,'-').toLowerCase();
        if(item){
          let slug_url = item.slug;
          if(item.slug.includes('material')){
            slug_url = 'material';
          }
          if(item.slug.includes('database')){
            slug_url = 'database';
          }
          if(item.slug.includes('tcdc-resource-center')){
            slug_url = 'tcdc-resource-center';
          }
          if(item.slug.includes('ebook')){
            slug_url = 'e-book';
            await this.$store.dispatch('Article/onGetAllEbooks', { page: 1, lang: this.lang });
          }
          if(item.slug.includes('article')){
            await this.$store.dispatch('Article/onGetAllArticles', { page: 1, lang: this.lang });
          }
          await this.$store.dispatch("ServiceMenu/setResourceCenterData", item.data);
          this.isLoading = false;
          this.$router.push(`/service/resource-center/${slug_url}`);
        }
      }
    }
  }
};
</script>

<style></style>
